import type { SyntheticEvent } from "react";
import type React from "react";
import { useState } from "react";

import classNames from "classnames";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Popover, PopoverTrigger } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import type { NavigationTabConfig } from "app/pages/sales-intelligence/modules/company-analysis/types/navigation-tabs";

import { DotsLoader } from "./DotsLoader";
import { StyledCountWrapper, StyledTabTitle, StyledPopoverContent } from "./styles";
import "./Tabs.scss";

type Props = {
    config: NavigationTabConfig;
    selectedSubTabIndex: number;
    onSubTabClick: (id: string) => void;
    isSelected: boolean;
};

export const TabItem: React.FC<Props> = ({ config, selectedSubTabIndex, onSubTabClick, isSelected }) => {
    const [isDDOpen, setIsDDOpen] = useState(false);

    const handleSubTabClick = (id: string, e: SyntheticEvent) => {
        setIsDDOpen(false);
        onSubTabClick(id);
        e.stopPropagation();
    };

    const subItemsToRender = config.items?.filter((subItem) => !subItem.isHidden) || [];

    if (subItemsToRender.length > 0) {
        return (
            <Popover
                placement="bottom-end"
                open={isDDOpen}
                onOpenChange={(isOpen) => setIsDDOpen(isOpen)}
                isHover
            >
                <PopoverTrigger asChild>
                    <StyledTabTitle withDD={Boolean(config.items?.length)}>
                        {config.title}
                        {typeof config.count !== "undefined" ? (
                            <StyledCountWrapper isWide={Boolean(config.count && config.count > 99)}>
                                {config.isLoading ? <DotsLoader /> : config.count}
                            </StyledCountWrapper>
                        ) : null}
                        <Box
                            key="chevron"
                            display="flex"
                        >
                            <SWReactIcons
                                size="sm"
                                iconName={isDDOpen ? "chev-up" : "chev-down"}
                                iconColor={isSelected ? colorsPalettes.blue[400] : colorsPalettes.carbon[400]}
                                hoverIconColor={isSelected ? colorsPalettes.blue[400] : colorsPalettes.carbon[500]}
                            />
                        </Box>
                    </StyledTabTitle>
                </PopoverTrigger>
                <StyledPopoverContent>
                    {subItemsToRender.map((subItem, subIndex) => (
                        <div
                            className={classNames("DropdownItem", {
                                "DropdownItem--selected": selectedSubTabIndex === subIndex,
                            })}
                            key={subItem.stateId}
                            onClick={(e) => handleSubTabClick(subItem.stateId, e)}
                        >
                            <div>{subItem.title}</div>
                        </div>
                    ))}
                </StyledPopoverContent>
            </Popover>
        );
    }

    return (
        <StyledTabTitle withDD={Boolean(config.items?.length)}>
            {config.title}
            {typeof config.count !== "undefined" ? (
                <StyledCountWrapper isWide={Boolean(config.count && config.count > 99)}>
                    {config.isLoading ? <DotsLoader /> : config.count}
                </StyledCountWrapper>
            ) : null}
        </StyledTabTitle>
    );
};
